export const hongbao = {
    hb: "レッドパケット",
    dps: "大放出",
    xdhb: "限定レッドパケット、数千万の特典があなたを待っています",
    fxhb: "レッドパケットをシェアして、さらなる報酬を獲得しよう",
    khb: "レッドパケットを開く",
    kqz: "開封中...",
    ylq: "受取済み",
    hdwks: "イベント未開始",
    hdjxz: "イベント開催中",
    hdyjs: "イベント終了",
    hddjs: "イベントカウントダウン",
    hdsj: "イベント期間",
    zwhd: "現在開催中のイベントはありません",
    hblsjlxq: "マイレッドパケット報酬履歴",
    jxz: "進行中",
    ygq: "期限切れ",
    dks: "開始待ち",
    zwjl: "報酬はまだありません",
    wnmztj: "イベント参加条件を満たしていません",
    wxts: "ご注意",
    yhwcrz: "ユーザーはKYC認証と電話番号の紐付けを完了しました",
    yhwcjy: "ユーザーは以下のいずれかを完了：現物取引≥100 USDT、または契約取引（レバレッジ除く）≥100 USDT、またはオプション取引≥100 USDT、またはGameFi取引≥100 USDT",
    djzh: "リスク管理対象または出金制限中のアカウントは、イベントに参加できません。",
    hdhbjl: "報酬獲得",
    sqbj: "もう少しでした",
    dkapp: "アプリを開く",
    smewm: "QRコードをスキャン",
    wchdtj: "イベント条件を達成し、レッドパケットを受け取る",
    fxhd: "イベントをシェアして、さらにレッドパケットを獲得",
    jdcz: "簡単操作で収益を獲得",
    hdhb: "イベントレッドパケット",
    zdqj: "指定期間",
    wcjye: "{type}取引高{text}が{amount} USDT以上であること",
    yhwfhtj: "レッドパケット開始前{time}以内に、ユーザーは条件に合う取引がありませんでした",
    hbsxq: "レッドパケット開始前{time}{day}以内に、ユーザーは{text}",
    bhgg: "レバレッジを除く",
    h: " または ",
}


// WEBPACK FOOTER //
// ./src/i18n/lang/hongbao/ja_JP.js